<template>
  <div class="px-2">
    <div
      class="rounded-large mx-auto mt-10 mb-4 flex max-h-[25vh] max-w-2xl flex-col gap-0.5 overflow-y-auto"
    >
      <div
        v-for="question in questions"
        :key="question.id"
        class="bg-surface-container rounded-extra-small first:rounded-t-large last:rounded-b-large group relative flex shrink-0 cursor-pointer flex-col overflow-hidden p-2 sm:p-3"
        @click="
          emit('navigate', {
            questionId: question.id,
            questionGroupId: question.questionGroupId,
          })
        "
      >
        <div class="flex flex-col">
          <p class="text-body-small sm:text-body-medium text-on-surface-variant grow">
            {{ question.content }}
          </p>
          <div class="mt-1 flex w-full flex-row items-center">
            <p
              v-if="question.feedbackText != undefined"
              class="text-body-small sm:text-body-medium text-primary line-clamp-1 grow italic"
            >
              {{ question.feedbackText }}
            </p>
            <div v-else class="grow"></div>
            <div
              v-if="question.feedbackValue != undefined"
              class="flex shrink-0 flex-row items-center gap-0.5"
            >
              <template v-for="scaleItem in question.scale?.items" :key="scaleItem.value">
                <div v-if="question.feedbackValue == scaleItem.value" class="h-4 w-4 sm:h-5 sm:w-5">
                  <BaseShape shape="very-sunny" class="text-primary" />
                </div>
                <div
                  v-else
                  class="bg-surface-container-low border-outline-variant h-3 w-3 rounded-full border sm:h-4 sm:w-4"
                ></div>
              </template>
            </div>
          </div>
        </div>
        <BaseStateLayer />
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
  import BaseShape from '@/core/components/base/shapes/BaseShape.vue'
  import BaseStateLayer from '@/core/components/base/state-layer/BaseStateLayer.vue'
  import type { FinishFeedbackQuestion } from '../../composables/use-finish-feedback-summary'

  interface Props {
    questions: ReadonlyArray<FinishFeedbackQuestion>
  }

  defineProps<Props>()

  const emit = defineEmits<{
    navigate: [question: { questionId: string; questionGroupId: string }]
  }>()
</script>
